import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { images } from "../../config/images";
import { getWashineMachine1StationDetails } from "../ProductionLine/services";
import { toast } from "react-toastify";

const WashingTab = ({setIsModalOpen, batchId}) => {
  const [washing1, setWashing1] = useState([]);

  useEffect(()=>{
    handleGetWashing1Data()
  },[batchId])

  const handleGetWashing1Data = async () => {
    try {
      const resp = await getWashineMachine1StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setWashing1(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setWashing1([]);

      console.log("handlesubmit", error);
    }
  };
  return (
    <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    WASHING MACHINE PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setIsModalOpen(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <Table className="dipping-params">
                    <TableHead>
                      <TableRow>
                        <TableCell>Max Temp (°C)</TableCell>
                        <TableCell>Min Temp (°C)</TableCell>
                        <TableCell>Time (Minutes)</TableCell>
                        <TableCell>Water Level (Liters)</TableCell>
                        <TableCell>Cycle Start Time</TableCell>
                        <TableCell>Cycle End Time</TableCell>
                        <TableCell>Operator</TableCell>
                        <TableCell>Supervisor</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="gloves-report-body">
                      {washing1?.map((e) => {
                        return (
                          <TableRow>
                            <TableCell>
                              {e.max_temp ? e.max_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.min_temp ? e.min_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.time_minutes ? e.time_minutes : ""}
                            </TableCell>
                            <TableCell>
                              {e.water_level ? e.water_level : ""}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_start_time
                                  ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_end_time
                                  ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e.operator ? e.operator : "--"}
                            </TableCell>
                            <TableCell>
                              {e.supervisor ? e.supervisor : "--"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setIsModalOpen(false)}
              ></div>
            </>
  );
};

export default WashingTab;
